// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  AnchorType,
  AnnotationType,
  Visibility,
} from "./types";

export default {
  presenceId: __t.u64(),
  sessionId: __t.option(__t.u64()),
  get anchorType() {
    return AnchorType;
  },
  anchorElementId: __t.option(__t.string()),
  worldX: __t.option(__t.f64()),
  worldY: __t.option(__t.f64()),
  worldZ: __t.option(__t.f64()),
  content: __t.string(),
  get annotationType() {
    return AnnotationType;
  },
  get visibility() {
    return Visibility;
  },
  visibleToIdentitiesJson: __t.option(__t.string()),
};
